import { LoadingOutlined } from '@ant-design/icons'
import { useLazyQuery, useMutation, useQuery } from '@apollo/client'
import { Col, Empty, Form as AntForm, Pagination, Row, Spin } from 'antd'
import { debounce } from 'lodash'
import React, { useState } from 'react'
import { BsTrash } from 'react-icons/bs'
import { MdLocationOn } from 'react-icons/md'
import PhoneInput from 'react-phone-input-2'
import { Dropdown as MultipleDropdown } from '../Post/style'

import countryList from 'react-select-country-list'
import {
  ADD_EDUCATION,
  ADD_SERVICE,
  DELETE_SCHOOL_DETAILS,
  DELETE_SERVICE,
  DISABLE_SERVICE,
  GET_AUTH_USER,
  GET_EDUCATION,
  GET_SERVICES,
  GET_SERVICE_TYPES,
  PLACE_DETAIL,
  PLACE_SEARCH,
  SCHOOL_SEARCH,
  UPDATE_DEFAULT_DESTINATION,
  UPDATE_SERVICE,
  FETCH_MY_QUESTIONS,
  FETCH_TAGS,
  UPDATE_PREFERENCE,
} from '../../app/apollo/index'
import { useAppSelector } from '../../app/hooks'
import Avatar from '../../globalComponents/Avatar'
import { LoggerButton } from '../../globalComponents/Button'
import { DropDown } from '../../globalComponents/DropDown'
import { Label } from '../../globalComponents/globalStyle'
import { ModalComponent } from '../../globalComponents/Modal'
import PostCard from '../../globalComponents/PostCard'
import { userInfo } from '../../globalComponents/slice/userDataSlice'
import { TextInput } from '../../globalComponents/TextInput'
import { NotificationAlert } from '../../utils/NotificationAlert'
import {
  Dropdown,
  InputDiv,
  Option,
  StyledAutoComplete,
  StyledDataPicker,
} from '../Onboard/Style'
import { DividerText, StyledDivider } from '../Topics/Style'
import {
  Container,
  Delete,
  InfoDiv,
  MobileNameBar,
  ModalContent,
  NameBar,
  PhoneDiv,
  PreferencesText,
  StyledCollapse,
  StyledInput,
  StyledPanel,
  StyledSwitch,
} from './Style'

const Profile = () => {
  const antIcon = <LoadingOutlined style={{ fontSize: 12 }} spin />
  const spinner = <Spin indicator={antIcon} />
  const [updateDefaultDestination] = useMutation(UPDATE_DEFAULT_DESTINATION)
  const [countryLoading, setCountryLoading] = useState(false)
  const [bizID, setBizID] = useState<number>()
  const [businessContent, setBusinessContent] = useState<any>()
  const [updateBizLoading, setUpdateBizLoading] = useState(false)
  const [bizActive, setBizActive] = useState(false)
  const [active, setActive] = useState<any>(false)
  const [businessActive, setBusinessActive] = useState<any>(false)
  const [loadingDisabled, setLoadingDisabled] = useState(false)
  const [preferencesActive, setPreferencesActive] = useState(false)
  const [activeUpdateSchool, setActiveUpdateSchool] = useState<any>(false)
  const [myQuestionsList, setMyQuestions] = useState([])
  const [deleteBusinessModal, setDeleteBusinessModal] = useState(false)
  const [deleteEducationModal, setDeleteEducationModal] = useState(false)
  const [deleteEducationId, setDeleteEducationID] = useState<any>()
  const [educationContentActive, setEducationContentActive] = useState(false)
  const userDetails = useAppSelector(userInfo)
  const options = React.useMemo(() => countryList().getData(), [])
  const [category, setCategory] = React.useState<any>([])
  const [placeSearchValues, setPlaceSearchValue] = React.useState<any>()
  const [placeSearchLocation, setPlaceSearchLocation] = React.useState<any>()
  const [load, setload] = React.useState(false)
  const { data, loading, error } = useQuery(GET_SERVICE_TYPES)
  const { data: datatags, loading: loadingTags, error: errorTags } = useQuery(
    FETCH_TAGS,
  )
  const [tags, setTags] = useState() as any
  const [createService] = useMutation(ADD_SERVICE)
  const [updateUserPreferences] = useMutation(UPDATE_PREFERENCE)
  const [fetchMyQuestionsAction, fetchMyquestionsData] = useLazyQuery(
    FETCH_MY_QUESTIONS,
  )
  const [updateTagsLoader, setUpdateTagsLoader] = useState(false)
  const [questionsList, setQuestionsList] = useState([])
  const [currentPage, setCurrentPage] = React.useState<any>(1)
  const [allPages, setAllPages] = React.useState<any>()
  const [placeSearch, placeSearchData] = useLazyQuery(PLACE_SEARCH)
  const [placeDetails, PlaceDetailsData] = useLazyQuery(PLACE_DETAIL)
  const [updateService] = useMutation(UPDATE_SERVICE)
  const [loadingQ, setLoadingQ] = React.useState(false)

  React.useEffect(() => {
    setCategory(data?.getServiceCategory)
  }, [data])
  const handleUpdatePreferences = async () => {
    if (tags?.length > 0) {
      setUpdateTagsLoader(true)
      try {
        const response = await updateUserPreferences({
          variables: {
            tags: tags,
          },
          refetchQueries: [
            {
              query: GET_AUTH_USER,
            },
          ],
        })
        if (response) {
          console.log('response updater', response)
          setUpdateTagsLoader(false)
          if (response?.data?.updateUserPreferences?.success) {
            NotificationAlert('success', 'Preferences updated successfully')
          } else {
            NotificationAlert('error', 'Unable to update preferences')
          }
        }
      } catch (e) {
        setUpdateTagsLoader(false)
        console.log('error', e)
      }
    }
  }

  const onChange = async (value: string) => {
    console.log('the value is ', value)
    try {
      placeSearch({
        variables: {
          place: value,
        },
      })
    } catch (e) {
      // console.log("error", e);
    }
  }
  const debounceOnChange = React.useCallback(debounce(onChange, 1000), [])
  React.useEffect(() => {
    setPlaceSearchLocation(
      PlaceDetailsData?.data?.placeDetail?.geometry?.location,
    )
  }, [placeSearchData])
  React.useEffect(() => {
    if (fetchMyquestionsData?.data?.myQuestions?.questions.length > 0) {
      setLoadingQ(false)
      setQuestionsList(fetchMyquestionsData?.data?.myQuestions?.questions)
      setAllPages(fetchMyquestionsData?.data?.myQuestions?.last_page)
    } else if (fetchMyquestionsData?.error) {
      // NotificationAlert('error', 'Error occured', 'Try again')
      console.log()
    } else if (fetchMyquestionsData?.loading === true) {
      setLoadingQ(true)
    }
  }, [fetchMyquestionsData])

  React.useEffect(() => {
    fetchMyQuestions(1, 15)
  }, [])
  // console.log('my Tags', datatags)

  const fetchMyQuestions = async (
    requestedPage: number,
    itemsPerPage: number,
  ) => {
    setLoadingQ(true)
    try {
      fetchMyQuestionsAction({
        variables: {
          requestedPage: requestedPage,
          itemsPerPage: itemsPerPage,
        },
      })
    } catch (e) {
      setLoadingQ(false)
      // console.log('questions error', e)
    }
  }
  const handleUpdateService = async (values: any) => {
    setUpdateBizLoading(true)
    try {
      const response = await updateService({
        refetchQueries: [
          {
            query: GET_SERVICES,
          },
        ],
        variables: {
          id: bizID,
          details: values.details,
          mobile: values.phone,
        },
      })
      if (response) {
        setUpdateBizLoading(false)
        if (response?.data?.updateService?.success) {
          NotificationAlert(
            'success',
            'Success',
            response?.data?.updateService?.msg,
          )
        } else {
          NotificationAlert(
            'error',
            'Error',
            response?.data?.updateService?.msg,
          )
        }
      }
    } catch (e) {
      setUpdateBizLoading(false)
      NotificationAlert('error', 'Error ocurred', 'Please try again')
      // console.log(e);
    }
  }

  const onFinisher = async (e: any, options: any) => {
    // console.log("onfinisher console", options);
    setPlaceSearchValue(options)
    try {
      placeDetails({
        variables: {
          place_id: options.key,
        },
      })
    } catch (e) {
      // console.log(e);
    }
    //   setPlaceSearchValue(options)
  }

  // console.log("place Details values", PlaceDetailsData);

  const onFinish = async (values: any) => {
    setload(true)
    // console.log(values);
    try {
      const response = await createService({
        refetchQueries: [{ query: GET_SERVICES }],
        variables: {
          name: values.businessName,
          serviceType_id: Number(values.businessType),
          mobile: values.phone,
          details: values.details,
          location: [
            {
              locationName: placeSearchValues.value,
              lat: placeSearchLocation.lat,
              lng: placeSearchLocation.lng,
            },
          ],
          email: values.businessMail,
        },
      })
      // console.log("create service response is", response);
      if (response) {
        setload(false)
        if (response?.data?.createService?.success) {
          NotificationAlert(
            'success',
            'Success',
            response?.data?.createService?.msg,
          )
          //  history.replace("/destination");
          setBusinessActive(false)
        } else {
          NotificationAlert(
            'error',
            'Error',
            response?.data?.createService?.msg,
          )
        }
      }
      setload(false)
    } catch (e) {
      setload(false)
      NotificationAlert('error', 'Error', 'Try again later')
      // console.log(e.message);
    }
    // history.replace("/destination");
  }

  //add education

  const [loadingSchool, setLoadingSchool] = useState(false)
  const [value, setValue] = React.useState<any>({})

  const [schoolSearch, searchSchoolData] = useLazyQuery(SCHOOL_SEARCH)
  const [addEducationDetails] = useMutation(ADD_EDUCATION)
  //   const changeHandler = async (value: any) => {
  //     // setValue(value);

  //   };

  const onChangeSchool = async (value: string) => {
    // console.log("the value is ", value);
    try {
      schoolSearch({
        variables: {
          byName: value,
        },
      })
    } catch (e) {
      // console.log("error", e);
    }
  }
  // console.log("the response of query is", searchSchoolData?.data?.schoolSearch);

  const onFinisherSchool = (value: any, options: any) => {
    setValue(options)
  }
  const debounceOnChangeSchool = React.useCallback(
    debounce(onChangeSchool, 500),
    [],
  )
  const handleCreateEducation = async (values: any) => {
    setLoadingSchool(true)
    // console.log(value);
    // console.log(values);
    const { year } = values
    // console.log("the year is", year.format("YYYY-MM-DD"));
    try {
      const response = await addEducationDetails({
        refetchQueries: [
          {
            query: GET_EDUCATION,
          },
        ],
        variables: {
          school_id: value?.key,
          schoolName: value?.value,
          endYear: year.format('YYYY-MM-DD'),
          course: values?.course,
        },
      })
      if (response) {
        setLoadingSchool(false)
        if (response.data?.addEducationDetails?.success) {
          NotificationAlert(
            'success',
            'Successful',
            response?.data?.addEducationDetails?.msg,
          )
          setActiveUpdateSchool(false)
        } else {
          NotificationAlert(
            'error',
            'Error',
            response?.data?.addEducationDetails?.msg,
          )
        }
      }
      //   console.log("update education response is ", response);
    } catch (e) {
      setLoadingSchool(false)
      NotificationAlert('error', 'Error', 'Unable to Add  Education Detail')
      // console.log(e);
    }
    // next();
  }
  const dateFormat = 'YYYY/MM/DD'

  const onFinishFailed = (errorInfo: any) => {
    // console.log(errorInfo);
  }
  console.log('userDetails', userDetails)
  //get education
  const {
    data: educationData,
    loading: educationLoading,
    error: educationError,
  } = useQuery(GET_EDUCATION)
  const {
    data: serviceData,
    loading: serviceLoading,
    error: serviceError,
  } = useQuery(GET_SERVICES)
  const [deleteEducationDetail] = useMutation(DELETE_SCHOOL_DETAILS)
  const [deleteService] = useMutation(DELETE_SERVICE)
  const [disableService] = useMutation(DISABLE_SERVICE)
  const handToggleBusinessActivity = async (id: number) => {
    setLoadingDisabled(true)
    try {
      const response = await disableService({
        variables: {
          id: id,
        },
        refetchQueries: [{ query: GET_SERVICES }],
      })
      if (response) {
        setLoadingDisabled(false)
        // console.log("disable response", response);
      }
    } catch (error) {
      setLoadingDisabled(false)
      // console.log(error);
      NotificationAlert('error', 'Error occured', 'Try Again Later')
    }
  }
  const handleDeleteBusiness = async () => {
    // console.log(businessContent?.id);
    try {
      const response = await deleteService({
        refetchQueries: [
          {
            query: GET_SERVICES,
          },
        ],
        variables: {
          id: Number(businessContent?.id),
        },
      })
      if (response?.data?.deleteService?.success) {
        setDeleteBusinessModal(false)
        NotificationAlert('success', 'Deleted Successfully', '')

        // console.log(response);
      } else {
        NotificationAlert('error', 'Error occured', 'Try Again Later')
      }
    } catch (e) {
      // console.log(e);
      NotificationAlert('error', 'Error occured', 'Try Again Later')
    }
  }

  const handleDeleteEducation = async () => {
    // console.log(deleteEducationId);
    try {
      const response = await deleteEducationDetail({
        variables: {
          id: Number(deleteEducationId),
        },
        refetchQueries: [
          {
            query: GET_EDUCATION,
          },
        ],
      })
      // console.log("delete education response", response);
      if (response?.data?.deleteEducationDetail?.success) {
        setDeleteEducationModal(false)
        NotificationAlert('success', 'Deleted Successfully', '')
      } else {
        NotificationAlert('error', 'Error occured', 'Try Again Later')
      }
    } catch (e) {
      // console.log("error", e);
      NotificationAlert('error', 'Error occured', 'Try Again Later')
    }
  }

  const handleDefaultUpdate = async (values: any) => {
    setCountryLoading(true)
    try {
      const response = await updateDefaultDestination({
        variables: {
          country: values.destination,
        },
        refetchQueries: [
          {
            query: GET_AUTH_USER,
          },
        ],
      })
      if (response) {
        setCountryLoading(false)
        if (response?.data?.updateDefaultDestination?.success) {
          NotificationAlert(
            'success',
            'Update Successfully',
            'Country of choice changed',
          )
          setActive(false)
        } else {
          NotificationAlert(
            'error',
            'Error',
            response?.data?.updateDefaultDestination?.msg,
          )
        }
        // console.log(response);
      }
    } catch (e) {
      // console.log(e.message);
      setCountryLoading(false)

      NotificationAlert('error', 'Error', 'Try Again Later')
    }
  }

  const handlePrevChange = () => {
    if (currentPage > 1) {
      fetchMyQuestions(currentPage - 1, 15)
      setCurrentPage(currentPage - 1)
    }
  }
  const handleNextChange = () => {
    if (currentPage < allPages) {
      fetchMyQuestions(currentPage + 1, 15)
      setCurrentPage(currentPage + 1)
    }
  }
  function itemRender(current?: any, type?: any, originalElement?: any) {
    if (type === 'prev') {
      return (
        <h5 style={{ color: 'blue', margin: 0 }} onClick={handlePrevChange}>
          Previous
        </h5>
      )
    }
    if (type === 'next') {
      return (
        <h5 style={{ color: 'blue', margin: 0 }} onClick={handleNextChange}>
          Next
        </h5>
      )
    }
    return originalElement
  }

  // console.log("education", educationData?.getUserEducationRecords);
  // console.log("services", serviceData);
  return (
    <Container>
      <ModalComponent
        visible={deleteBusinessModal}
        onCancel={() => setDeleteBusinessModal(false)}
      >
        <ModalContent>
          <h3>
            Are you sure you want to delete <span>{businessContent?.name}</span>{' '}
            business?
          </h3>
          <div>
            <button onClick={() => handleDeleteBusiness()}>Confirm</button>
          </div>
        </ModalContent>
      </ModalComponent>
      <ModalComponent
        onCancel={() => setDeleteEducationModal(false)}
        visible={deleteEducationModal}
      >
        <ModalContent>
          <h3>Are you sure you want to delete education records?</h3>
          <div>
            <button onClick={() => handleDeleteEducation()}>Confirm</button>
          </div>
        </ModalContent>
      </ModalComponent>

      <Row style={{ height: '100%', width: '100%' }} justify="space-between">
        <Col xs={{ span: 24 }} md={{ span: 7 }}>
          <div>
            <Avatar />
            <br />
            <MobileNameBar>
              <h3>
                {userDetails?.firstname} {userDetails?.lastname}{' '}
              </h3>
              <h2>
                <MdLocationOn />
                <span> {userDetails?.currentCountry?.country}</span>
              </h2>
            </MobileNameBar>
            <InfoDiv>
              <h3>BASIC INFORMATION</h3>
              <h2>
                Phone: <span>{userDetails?.phone}</span>{' '}
              </h2>
              <h2>
                E-mail: <span> {userDetails?.email}</span>
              </h2>
              <h2>
                Home country:{' '}
                <span>{userDetails?.currentCountry?.country}</span>
              </h2>
              <h2 style={{ display: 'flex', width: '100%' }}>
                Country of choice:
                <span>{userDetails?.defaultDestination}</span>
              </h2>
              <StyledCollapse
                activeKey={active && '9'}
                onChange={(e) => {
                  setActive(!active)
                  // console.log("active", e);
                }}
                accordion
                destroyInactivePanel={true}
              >
                <StyledPanel header={`Edit choice country`} key="9">
                  <AntForm
                    layout="vertical"
                    onFinish={handleDefaultUpdate}
                    // onFinishFailed={onFinishFailed}
                  >
                    <AntForm.Item name="destination">
                      <DropDown
                        required={true}
                        placeholder="Select a Country"
                        values={options}
                        // onChange={changeHandler}
                      />
                    </AntForm.Item>
                    <LoggerButton
                      style={{ boxShadow: 'none' }}
                      htmlType="submit"
                      loading={countryLoading}
                      text="Update"
                    />
                  </AntForm>
                </StyledPanel>
              </StyledCollapse>
              <br />
              <h3>USER PREFERENCES</h3>
              {userDetails?.usertags.length < 1 && <h2>NO RECORD YET</h2>}
              {userDetails?.usertags?.length > 0 && (
                <div style={{ display: 'flex' }}>
                  {userDetails?.usertags?.map((tags: any) => {
                    // console.log('tags', tags)
                    return <PreferencesText>{tags}</PreferencesText>
                  })}
                </div>
              )}
              <StyledCollapse
                onChange={() => setPreferencesActive(!preferencesActive)}
                //@ts-ignore
                activeKey={preferencesActive && '4'}
                accordion
                destroyInactivePanel={true}
              >
                <StyledPanel header={`Update Preferences`} key="4">
                  <MultipleDropdown
                    onChange={(e) => setTags(e)}
                    placeholder="select preferences"
                    style={{ height: '100%' }}
                    mode="multiple"
                  >
                    {datatags?.allTagsAvailable?.map((tags: any, id: any) => (
                      <Option key={id} value={tags}>
                        {tags}
                      </Option>
                    ))}
                  </MultipleDropdown>
                  {/* <Button /> */}
                  <br />
                  <br />
                  <LoggerButton
                    onClick={handleUpdatePreferences}
                    loading={updateTagsLoader}
                    text="Update"
                  />
                </StyledPanel>
              </StyledCollapse>
            </InfoDiv>
          </div>
        </Col>
        <Col xs={{ span: 24 }} md={{ span: 15 }}>
          <div>
            <NameBar>
              <h3>
                {userDetails?.firstname} {userDetails?.lastname}{' '}
              </h3>
              <h2>
                <MdLocationOn />
                <span> {userDetails?.currentCountry?.country}</span>
              </h2>
            </NameBar>
            <br />
            <InfoDiv>
              <h3>Education Details</h3>
              {educationLoading && <h2>Loading, please wait</h2>}
              {educationData?.getUserEducationRecords?.length === 0 && (
                <>
                  <h2>NO RECORD YET</h2>
                  <StyledCollapse
                    onChange={() => setActiveUpdateSchool(!activeUpdateSchool)}
                    activeKey={activeUpdateSchool && '9'}
                    accordion
                    destroyInactivePanel={true}
                  >
                    <StyledPanel header={`Create education record`} key="9">
                      <AntForm
                        layout="vertical"
                        onFinish={handleCreateEducation}
                        onFinishFailed={onFinishFailed}
                      >
                        <AntForm.Item
                          name="country"
                          rules={[
                            {
                              required: true,
                              message: 'field is required',
                            },
                          ]}
                          label={
                            <Label>
                              <h3>Select Country</h3>
                            </Label>
                          }
                        >
                          <div>
                            <DropDown
                              required={true}
                              placeholder="Select a Country"
                              values={options}
                              //   onChange={changeHandler}
                            />
                          </div>
                        </AntForm.Item>
                        <AntForm.Item
                          name="schoolName"
                          rules={[
                            {
                              required: true,
                              message: 'field is required',
                            },
                          ]}
                          label={
                            <Label>
                              <h3>Name of School</h3>
                            </Label>
                          }
                        >
                          <InputDiv>
                            <StyledAutoComplete
                              onChange={debounceOnChangeSchool}
                              onSelect={onFinisherSchool}
                              placeholder="Enter school name"
                            >
                              {searchSchoolData?.loading ? (
                                <StyledAutoComplete.Option value={''}>
                                  Loading...
                                </StyledAutoComplete.Option>
                              ) : (
                                searchSchoolData?.data?.schoolSearch.map(
                                  (val: any) => (
                                    <StyledAutoComplete.Option
                                      key={val?.id}
                                      value={val?.name}
                                    >
                                      {val?.name}
                                    </StyledAutoComplete.Option>
                                  ),
                                )
                              )}
                            </StyledAutoComplete>
                          </InputDiv>
                        </AntForm.Item>
                        <AntForm.Item
                          name="course"
                          rules={[
                            {
                              required: true,
                              message: 'field is required',
                            },
                          ]}
                          label={
                            <Label>
                              <h3>Course of Study</h3>
                            </Label>
                          }
                        >
                          <div>
                            <TextInput
                              required={true}
                              type="text"
                              placeholder="Enter course of study"
                              name="course"
                            />
                          </div>
                        </AntForm.Item>
                        <AntForm.Item
                          name="year"
                          rules={[
                            {
                              required: true,
                              message: 'field is required',
                            },
                          ]}
                          label={
                            <Label>
                              <h3>Year of Graduation</h3>
                            </Label>
                          }
                        >
                          {/* <div> */}
                          <StyledDataPicker
                            // defaultValue={moment("2015/01/01", dateFormat)}
                            format={dateFormat}
                          />
                          {/* </div> */}
                        </AntForm.Item>
                        <br />

                        <LoggerButton
                          loading={loadingSchool}
                          htmlType="submit"
                          width="100%"
                          text="Update School"
                        />
                      </AntForm>
                    </StyledPanel>
                  </StyledCollapse>
                </>
              )}
              {educationData?.getUserEducationRecords?.length > 0 && (
                <>
                  {' '}
                  <h2>
                    School Name:
                    <span>
                      {' '}
                      {educationData?.getUserEducationRecords[0]?.schoolName}
                    </span>
                  </h2>
                  <h2>
                    Course:
                    <span>
                      {' '}
                      {educationData?.getUserEducationRecords[0]?.course ||
                        'Not available'}
                    </span>
                  </h2>
                  <h2>
                    Graduation Year :
                    <span>
                      {educationData?.getUserEducationRecords[0]?.endYear}
                    </span>
                  </h2>
                  <h2>
                    <Delete
                      onClick={() => {
                        setDeleteEducationModal(true)
                        setDeleteEducationID(
                          educationData?.getUserEducationRecords[0]?.id,
                        )
                      }}
                    >
                      <h1>
                        <BsTrash />
                      </h1>
                      <h5>delete academic record</h5>
                    </Delete>
                  </h2>
                </>
              )}

              <br />
              <h3>Business Details</h3>
              <StyledCollapse
                onChange={() => setBusinessActive(!businessActive)}
                activeKey={businessActive && '9'}
                accordion
                destroyInactivePanel={true}
              >
                <StyledPanel header={`Add new business`} key="9">
                  <AntForm
                    layout="vertical"
                    onFinish={onFinish}
                    // onFinishFailed={onFinishFailed}
                  >
                    <AntForm.Item
                      name="businessType"
                      rules={[
                        {
                          required: true,
                          message: 'field is required',
                        },
                      ]}
                      label={
                        <Label>
                          <h3>Business Type</h3>
                        </Label>
                      }
                    >
                      <InputDiv>
                        <Dropdown required>
                          <option value="" />
                          {category?.map((categories: any) => (
                            <Option key={categories.id} value={categories.id}>
                              {categories.serviceCategory}
                            </Option>
                          ))}
                        </Dropdown>
                      </InputDiv>
                    </AntForm.Item>
                    <AntForm.Item
                      name="businessName"
                      rules={[
                        {
                          required: true,
                          message: 'field is required',
                        },
                      ]}
                      label={
                        <Label>
                          <h3>Business Name</h3>
                        </Label>
                      }
                    >
                      <div>
                        <TextInput
                          required={true}
                          type="text"
                          placeholder="Enter business name"
                          name="businessName"
                        />
                      </div>
                    </AntForm.Item>
                    <AntForm.Item
                      name="businessAddress"
                      rules={[
                        {
                          required: true,
                          message: 'field is required',
                        },
                      ]}
                      label={
                        <Label>
                          <h3>Business Address</h3>
                        </Label>
                      }
                    >
                      <InputDiv>
                        <StyledAutoComplete
                          onChange={debounceOnChange}
                          onSelect={onFinisher}
                          placeholder="Enter business address"
                        >
                          {placeSearchData?.loading ? (
                            <StyledAutoComplete.Option value={''}>
                              Loading...
                            </StyledAutoComplete.Option>
                          ) : (
                            placeSearchData?.data?.placeSearch?.predictions.map(
                              (val: any) => (
                                <StyledAutoComplete.Option
                                  key={val?.place_id}
                                  value={val?.description}
                                >
                                  {val?.description}
                                </StyledAutoComplete.Option>
                              ),
                            )
                          )}
                        </StyledAutoComplete>
                      </InputDiv>
                    </AntForm.Item>

                    <AntForm.Item
                      name="businessMail"
                      rules={[
                        {
                          required: true,
                          message: 'field is required',
                        },
                      ]}
                      label={
                        <Label>
                          <h3>Business Mail</h3>
                        </Label>
                      }
                    >
                      <div>
                        <TextInput
                          required={true}
                          type="email"
                          placeholder="Enter business mail"
                          name="businessMail"
                        />
                      </div>
                    </AntForm.Item>
                    <AntForm.Item
                      name="phone"
                      rules={[
                        {
                          required: true,
                          message: 'field is required',
                        },
                      ]}
                      label={
                        <Label>
                          <h3>Phone Number</h3>
                        </Label>
                      }
                    >
                      <PhoneDiv>
                        <PhoneInput
                          inputClass="inputStyle"
                          containerClass="containerStyle"
                          dropdownClass="dropdownStyle"
                          buttonClass="buttonStyle"
                          searchClass="searchStyle"
                          country={'us'}
                          // onChange={(e, c) => setCountry(c)}
                        />
                      </PhoneDiv>
                    </AntForm.Item>
                    <AntForm.Item
                      name="details"
                      rules={[
                        {
                          required: true,
                          message: 'field is required',
                        },
                      ]}
                      label={
                        <Label>
                          <h3>Business Details</h3>
                        </Label>
                      }
                    >
                      <div>
                        {/* <InputDiv> */}
                        <StyledInput
                          autoSize={{ minRows: 3, maxRows: 3 }}
                          // bordered={false}
                          placeholder="write your description here..."
                        />
                      </div>
                      {/* </InputDiv> */}
                    </AntForm.Item>
                    <br />

                    <LoggerButton
                      loading={load}
                      htmlType="submit"
                      width="100%"
                      text="ADD BUSINESS"
                    />
                  </AntForm>
                </StyledPanel>
              </StyledCollapse>
              {serviceLoading && 'Loading, please wait...'}
              {serviceData?.myService?.length === 0 && <h2>NO RECORD YET</h2>}
              {serviceData &&
                serviceData?.myService.map((service: any, id: any) => (
                  <>
                    <h2>Business {id + 1}</h2>
                    <h2>
                      Name: <span>{service?.name}</span>
                    </h2>
                    <h2>
                      E-mail: <span> {service?.email}</span>
                    </h2>
                    <h2>
                      Phone:{' '}
                      <span>
                        {service?.mobile ? service?.mobile : 'Not Available'}
                      </span>{' '}
                    </h2>
                    <h2>
                      Details:{' '}
                      <span>{service?.details || 'Not Available'}</span>{' '}
                    </h2>
                    <h2>
                      Address: <span>{service?.location[0]?.locationName}</span>{' '}
                    </h2>
                    <h2>
                      Country:{' '}
                      <span>
                        {' '}
                        {service?.countries
                          ? service?.countries
                          : 'Not Available'}
                      </span>{' '}
                    </h2>
                    <h2>
                      City/State:{' '}
                      <span>{service?.cities || 'Not Available'}</span>{' '}
                    </h2>
                    <h2 style={{ display: 'flex' }}>
                      <Delete
                        onClick={() => {
                          setBusinessContent(service)
                          setDeleteBusinessModal(true)
                        }}
                      >
                        <h1>
                          <BsTrash />
                        </h1>
                        <h5>delete business</h5>
                      </Delete>
                      <Delete>
                        <StyledSwitch
                          onChange={() =>
                            handToggleBusinessActivity(Number(service?.id))
                          }
                          checked={!service?.isDisabled}
                          size="small"
                        />
                        {service?.isDisabled ? (
                          <h5>enable business</h5>
                        ) : (
                          <h5>disable business</h5>
                        )}
                      </Delete>
                      {loadingDisabled && spinner}
                    </h2>
                    {/* <br /> */}
                    <StyledCollapse
                      // activeKey={bizActive && id}
                      onChange={() => {
                        setBizID(Number(service?.id))
                        // id + 1 !== 0 && setBizActive(true);
                      }}
                      accordion
                      destroyInactivePanel={true}
                    >
                      <StyledPanel
                        header={`Edit business ${id + 1} details`}
                        key={id}
                      >
                        <AntForm
                          layout="vertical"
                          onFinish={handleUpdateService}
                          // onFinishFailed={onFinishFailed}
                        >
                          <AntForm.Item
                            name="phone"
                            rules={[
                              {
                                required: true,
                                message: 'field is required',
                              },
                            ]}
                            label={
                              <Label>
                                <h3>Phone Number</h3>
                              </Label>
                            }
                          >
                            <PhoneDiv>
                              <PhoneInput
                                value={service?.mobile || ''}
                                inputClass="inputStyle"
                                containerClass="containerStyle"
                                dropdownClass="dropdownStyle"
                                buttonClass="buttonStyle"
                                searchClass="searchStyle"
                                country={'us'}
                                // onChange={(e, c) => setCountry(c)}
                              />
                            </PhoneDiv>
                          </AntForm.Item>
                          <AntForm.Item
                            name="details"
                            rules={[
                              {
                                required: true,
                                message: 'field is required',
                              },
                            ]}
                            label={
                              <Label>
                                <h3>Business Details</h3>
                              </Label>
                            }
                          >
                            <div>
                              {/* <InputDiv> */}
                              <StyledInput
                                autoSize={{ minRows: 3, maxRows: 3 }}
                                value={service?.details || ''}
                                // bordered={false}
                                placeholder="write your description here..."
                              />
                            </div>
                            {/* </InputDiv> */}
                          </AntForm.Item>
                          <br />

                          <LoggerButton
                            loading={updateBizLoading}
                            htmlType="submit"
                            width="100%"
                            text="Update"
                          />
                        </AntForm>
                      </StyledPanel>
                    </StyledCollapse>
                    {/* <div style={{ display: "flex" }}>
                      <LoggerButton text="Update Details" />
                      <LoggerButton
                        style={{ background: "red" }}
                        text="Delete Business"
                      />
                    </div> */}
                    <br />
                  </>
                ))}
            </InfoDiv>
          </div>
          <br />
          <StyledDivider orientation="left">
            <DividerText>MY QUESTIONS</DividerText>
          </StyledDivider>
          {questionsList.length > 0 && <PostCard posts={questionsList} />}{' '}
          {loadingQ && <Spin indicator={antIcon} />}
          {questionsList.length < 1 && <Empty />}
          {questionsList?.length > 0 && (
            <Pagination
              style={{ marginBottom: '10vh' }}
              current={currentPage}
              total={allPages}
              pageSize={1}
              defaultPageSize={allPages}
              showSizeChanger={false}
              itemRender={itemRender}
              showTotal={(total) => `Total: ${total} list`}
            />
          )}
        </Col>
      </Row>
    </Container>
  )
}

export default Profile
